<template>
  <v-form v-model="valid" style="width: 100%;">
    <v-container fluid>

      <v-row v-if="disbursing">
        <v-col cols="6">
          <CurrencyInput v-model="cash" label="Cash Received" />
        </v-col>
        <v-col>
          <v-btn @click="rollover" color="primary" :disabled="!mayRollover">Rollover</v-btn>
        </v-col>
      </v-row>

      <v-row v-else>
        <ServerSideResult :test="rolloverProcess">
          <v-col cols="12" class="text-h4 text--primary text-left">
            Thank you. Your rollover has been processed.
          </v-col>
        </ServerSideResult>
      </v-row>

    </v-container>
  </v-form>
</template>

<script>
import lookups from '@/mixins/lookups';

import CurrencyInput from "@/components/CurrencyInput";
import ServerSideResult from "@/components/ServerSideResult";

export default {

  components: { CurrencyInput, ServerSideResult },

  props: {
    instrument: {
      type: Object,
      required: false,
    },
    customer: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      valid: false,
      cash: 0,
      disbursing: true,
      rolloverProcess: undefined,
    }
  },

  computed: {
    rolloverAmount() { return ((this.instrument.rollover_amount || 0)/100.0); },
    mayRollover() { return this.valid && ( (this.instrument) && (this.cash>=this.rolloverAmount ) ) },
  },

  watch: {
    instrument(to) {
      if (to && this.cash==0) {
        this.cash = this.settlementAmount;
      }
    }
  },

  methods: {
    // validate() { this.$refs.rolloverForm.validate(); },
    rollover() {
      this.disbursing = false;
      this.remoteLookup('instrumentUltimateTzSalaryAdvanceRollover', {
        uuid: this.customer.uuid,
        id: this.instrument.id,
        cash: this.cash,
      }).then( e => this.rolloverProcess = 'done' ).catch(e => this.rolloverProcess = null);
    },
  },

  mixins: [lookups],

}
</script>
